<!-- =========================================================================================
  File Name: VerticalNavMenu.vue
  Description: Vertical NavMenu Component
  Component Name: VerticalNavMenu
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="parentx">
    <vs-sidebar class="v-nav-menu items-no-padding" v-model="isVerticalNavMenuActive" ref="verticalNavMenu"
      default-index="-1" :click-not-close="clickNotClose" :reduce-not-rebound="reduceNotRebound" :parent="parent"
      :hiddenBackground="clickNotClose" :reduce="reduce" v-hammer:swipe="onMenuSwipe">
      <div @mouseenter="mouseEnter" @mouseleave="mouseLeave" id="menu-with-loading" class="vs-con-loading__container">
        <!-- Header -->
        <div class="header-sidebar flex items-center justify-between" slot="header">
          <!-- Logo -->
          <router-link tag="div" class="vx-logo cursor-pointer flex items-center" :to="homeUrl">
            <img
              v-if="roleLogo"
              :src="roleLogo"
              :style="{ width: 'auto', height: roleLogoHeight + 'px', marginLeft: '-15px', marginRight: '-8px' }"
              alt="logo"
            />
            <!-- <logo v-else class="w-10 mr-4 fill-current text-primary" /> -->
            <img v-else src="/sgs-logo.png" width="70" height="32">

            <span class="vx-logo-text text-primary" style="font-size: 19px !important;" v-show="isMouseEnter || !reduce"
              v-if="title">{{ appTitle }}</span>
          </router-link>
          <!-- /Logo -->

          <!-- Menu Buttons -->
          <div>
            <!-- Close Button -->
            <template v-if="showCloseButton">
              <feather-icon icon="XIcon" class="m-0 cursor-pointer" @click="
                $store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
                " />
            </template>

            <!-- Toggle Buttons -->
            <template v-else-if="!showCloseButton && !verticalNavMenuItemsMin">
              <feather-icon id="btnVNavMenuMinToggler" class="mr-0 cursor-pointer"
                :icon="reduce ? 'CircleIcon' : 'DiscIcon'" svg-classes="stroke-current text-primary"
                @click="toggleReduce(!reduce)" />
            </template>
          </div>
          <!-- /Menu Toggle Buttons -->
        </div>
        <!-- /Header -->

        <!-- Header Shadow -->
        <div class="shadow-bottom" v-show="showShadowBottom" />

        <!-- Menu Items -->
        <component :is="scrollbarTag" ref="verticalNavMenuPs" class="scroll-area-v-nav-menu pt-2" :settings="settings"
          @ps-scroll-y="psSectionScroll" @scroll="psSectionScroll" :key="$vs.rtl">
          <template v-if="$route.name === 'menu-builder'">
            <draggable :animation="500" group="menu-items" @end="onEnd">
              <template v-for="(item, index) in menuItemsUpdated">
                <!-- Group Header -->
                <span v-if="item.header && !verticalNavMenuItemsMin" onmousedown="return false" :data-hash="item.hash"
                  class="navigation-header truncate"
                  style="overflow-x: auto!important; white-space: nowrap!important;"
                  :key="`header-${index}`">
                  <span
                    style="font-size: 0.9rem;display: inline-block;font-weight: 500;text-transform: uppercase;color: #999;">{{
                      $t(item.i18n) || ($i18n.locale === 'en' && item.header_en ? item.header_en : item.header) }}</span>
                  <span style="display: inline-block; margin-left: 20px!important;">
                    <feather-icon icon="Edit2Icon" @click="editButtonClick(item.hash)" svgClasses="h-4 w-4"
                      class="ml-auto text-primary" style="cursor: pointer;display: inline-block;" />
                    <feather-icon icon="TrashIcon" @click="deleteButtonClick(item.hash)" svgClasses="h-4 w-4"
                      class="text-danger" style="cursor: pointer;display: inline-block;" />
                  </span>
                </span>
                <!-- /Group Header -->

                <template v-else-if="!item.header">
                  <!-- Nav-Item -->

                  <v-nav-menu-item v-if="!item.submenu" :key="`item-${item.hash}`" :index="index"
                    :to="item.slug !== 'external' ? item.url : null" :href="item.slug === 'external' ? item.url : null"
                    :icon="item.icon" :target="item.target" :isDisabled="item.isDisabled" :slug="item.slug"
                    :cursorMove="true" :actionButtons="true" :hash="item.hash" :remove="item.remove"
                    :destinationTypeId="item.destination_type_id ? item.destination_type_id : null">
                    <span v-show="!verticalNavMenuItemsMin" class="truncate">{{
                      $t(item.i18n) || ($i18n.locale === 'en' && item.name_en ? item.name_en : item.name)
                    }}</span>
                    <vs-chip class="ml-auto" :color="item.tagColor" v-if="item.tag && (isMouseEnter || !reduce)">{{
                      item.tag }}</vs-chip>
                    <feather-icon icon="Edit2Icon" @click="editButtonClick(item.hash)" svgClasses="h-4 w-4"
                      class="ml-auto text-primary" style="cursor: pointer;" />
                    <feather-icon icon="TrashIcon" @click="deleteButtonClick(item.hash)" svgClasses="h-4 w-4"
                      class="text-danger" style="cursor: pointer;" />
                  </v-nav-menu-item>

                  <!-- Nav-Group -->
                  <template v-else>
                    <v-nav-menu-group :key="`group-${item.hash}`" :openHover="openGroupHover" :group="item"
                      :groupIndex="index" :open="true" :cursorMove="true" :hash="item.hash" />
                  </template>
                  <!-- /Nav-Group -->
                </template>
              </template>
            </draggable>
          </template>

          <template v-else>
            <template v-for="(item, index) in menuItemsUpdated">
              <!-- Group Header -->
              <span v-if="item.header && !verticalNavMenuItemsMin" class="navigation-header truncate"
                :key="`header-${index}`">
                {{ $t(item.i18n) || ($i18n.locale === 'en' && item.header_en ? item.header_en : item.header) }}
              </span>
              <!-- /Group Header -->

              <template v-else-if="!item.header">
                <!-- Nav-Item -->

                <v-nav-menu-item v-if="!item.submenu" :key="`item-${item.hash}`" :index="index"
                  :to="item.slug !== 'external' ? item.url : null" :href="item.slug === 'external' ? item.url : null"
                  :icon="item.icon" :target="item.target" :isDisabled="item.isDisabled" :slug="item.slug"
                  :destinationTypeId="item.destination_type_id ? item.destination_type_id : null">
                  <span v-show="!verticalNavMenuItemsMin" class="truncate">{{
                    $t(item.i18n) || ($i18n.locale === 'en' && item.name_en ? item.name_en : item.name)
                  }}</span>
                  <vs-chip class="ml-auto" :color="item.tagColor" v-if="item.tag && (isMouseEnter || !reduce)">{{
                    item.tag }}</vs-chip>
                </v-nav-menu-item>

                <!-- Nav-Group -->
                <template v-else>
                  <v-nav-menu-group :key="`group-${item.hash}`" :openHover="openGroupHover" :group="item"
                    :groupIndex="index" :open="isGroupActive(item)" />
                </template>
                <!-- /Nav-Group -->
              </template>
            </template>
          </template>
        </component>
        <!-- /Menu Items -->
      </div>
    </vs-sidebar>

    <!-- Swipe Gesture -->
    <div v-if="!isVerticalNavMenuActive" class="v-nav-menu-swipe-area" v-hammer:swipe="onSwipeAreaSwipe" />
    <!-- /Swipe Gesture -->
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VNavMenuGroup from "./VerticalNavMenuGroup.vue";
import VNavMenuItem from "./VerticalNavMenuItem.vue";
import draggable from "vuedraggable";

import Logo from "../Logo.vue";
import { getApplicationLocalStorageItem } from "../../../helpers";

export default {
  name: "v-nav-menu",
  components: {
    VNavMenuGroup,
    VNavMenuItem,
    VuePerfectScrollbar,
    Logo,
    draggable
  },
  props: {
    logo: { type: String },
    openGroupHover: { type: Boolean, default: false },
    parent: { type: String },
    reduceNotRebound: { type: Boolean, default: true },
    navMenuItems: { type: Array, required: true },
    title: { type: String }
  },
  data: () => ({
    clickNotClose: false, // disable close navMenu on outside click
    isMouseEnter: false,
    reduce: false, // determines if navMenu is reduce - component property
    showCloseButton: false, // show close button in smaller devices
    settings: {
      // perfectScrollbar settings
      maxScrollbarLength: 60,
      wheelSpeed: 1,
      swipeEasing: true
    },
    showShadowBottom: false,
    appTitle: "",
    homeUrl: "",
    iconOptions: []
  }),
  computed: {
    isGroupActive() {
      return item => {
        const path = this.$route.fullPath;
        const routeParent = this.$route.meta
          ? this.$route.meta.parent
          : undefined;
        let open = false;

        const func = item => {
          if (item.submenu) {
            item.submenu.forEach(item => {
              if (
                item.url &&
                (path === item.url || routeParent === item.slug)
              ) {
                open = true;
              } else if (item.submenu) {
                func(item);
              }
            });
          }
        };
        func(item);
        return open;
      };
    },
    menuItemsUpdated() {

      const clone = this.navMenuItems.slice();

      for (const [index, item] of this.navMenuItems.entries()) {
        if (item.header && item.items.length && (index || 1)) {
          const i = clone.findIndex(ix => ix.header === item.header);
          for (const [subIndex, subItem] of item.items.entries()) {
            clone.splice(i + 1 + subIndex, 0, subItem);
          }
        }
      }

      return clone;
    },
    isVerticalNavMenuActive: {
      get() {
        return this.$store.state.isVerticalNavMenuActive;
      },
      set(val) {
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", val);
      }
    },
    layoutType() {
      return this.$store.state.mainLayoutType;
    },
    reduceButton: {
      get() {
        return this.$store.state.reduceButton;
      },
      set(val) {
        this.$store.commit("TOGGLE_REDUCE_BUTTON", val);
      }
    },
    isVerticalNavMenuReduced() {
      return Boolean(this.reduce && this.reduceButton);
    },
    roleLogo() {
      return this.$store.state.auth.roleLogo;
    },
    roleLogoHeight() {
      return this.$store.state.auth.roleLogoHeight;
    },
    verticalNavMenuItemsMin() {
      return this.$store.state.verticalNavMenuItemsMin;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    }
  },
  watch: {
    $route() {
      if (this.isVerticalNavMenuActive && this.showCloseButton)
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
    },
    "$store.state.menuBuilder.currentItemToDelete"(val) {
      setTimeout(() => {
        this.$store.commit("auth/REMOVE_APPLICATION_MENU_ITEM", val);
      }, 1000);
    },
    reduce(val) {
      const verticalNavMenuWidth = val
        ? "reduced"
        : this.$store.state.windowWidth < 1200
          ? "no-nav-menu"
          : "default";
      this.$store.dispatch("updateVerticalNavMenuWidth", verticalNavMenuWidth);

      setTimeout(function () {
        window.dispatchEvent(new Event("resize"));
      }, 100);
    },
    layoutType() {
      this.setVerticalNavMenuWidth();
    },
    reduceButton() {
      this.setVerticalNavMenuWidth();
    },
    windowWidth() {
      this.setVerticalNavMenuWidth();
    }
  },
  methods: {
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#div-with-loading",
        scale: 0.6
      });
      // setTimeout( ()=> {
      //   this.$vs.loading.close('#div-with-loading > .con-vs-loading')
      // }, 3000);
    },
    editButtonClick(hash) {
      this.$store.commit("menuBuilder/setCurrentMenuToEdit", {
        hash: hash
      });
    },
    deleteButtonClick(hash, name) {
      this.$store.commit("menuBuilder/setCurrentMenuToDelete", {
        hash: hash
      });
    },
    validLayout() {
      const menu = document.querySelector(
        ".vs-sidebar--items > div > section > div"
      );

      const menuArr = Array.prototype.slice.call(menu.children);

      let hasHeader = false;

      let invalidFormat = false;

      menuArr.every((item, index) => {
        if (!hasHeader && item.tagName.toLowerCase() === "div") {
          invalidFormat = true;
        }

        if (!invalidFormat) {
          this.$vs.notify({
            title: "Atenção",
            text: "Há itens fora da âncora",
            iconPack: "feather",
            icon: "icon-icon-alert-circle",
            color: "warning"
          });

          return false;
        }

        return true;
      });

      return !invalidFormat;
    },
    async onEnd(event) {
      this.$vs.loading({
        container: "#menu-with-loading",
        scale: 0.6
      });

      if (
        document
          .querySelector(".vs-sidebar--items > div > section > div")
          .children[0].tagName.toLowerCase() !== "span"
      ) {
        // CHECK IF THERE's ANY ITEM OFF THE ANCHOR

        const firstAnchor = document.querySelector(
          ".vs-sidebar--items > div > section > div > span"
        );

        document
          .querySelector(".vs-sidebar--items > div > section > div")
          .insertBefore(
            firstAnchor,
            document.querySelector(".vs-sidebar--items > div > section > div")
              .children[0]
          );

        this.$vs.notify({
          title: "Atenção",
          text: "Todos os itens precisam ficar abaixo do menu Âncora",
          iconPack: "feather",
          icon: "icon-icon-alert-circle",
          color: "warning"
        });

        return;
      }

      const itemParentHash = event.item.getAttribute("data-parent-hash");

      let newParentHash = null;

      let previous = event.item.previousSibling;

      if (previous !== null) {
        if (previous.tagName.toLowerCase() !== "li") {
          while (previous.tagName.toLowerCase() !== "span") {
            previous = previous.previousSibling;
          }

          newParentHash = previous.getAttribute("data-hash");

          event.item.setAttribute("data-parent-hash", newParentHash);
        }

        // else if(previous.tagName.toLowerCase() === 'li') {

        //   // Grupo de Âncora para Grupo

        //   if(event.item.classList.contains('vs-sidebar-group')) {
        //     console.log(event.item.classList.contains('vs-sidebar-group'))

        //     return
        //   }

        //   return
        // }
      } else {
        if (
          event.item.parentElement.parentElement.tagName.toLowerCase() === "ul"
        ) {
          newParentHash = event.item.parentElement.parentElement.parentElement.getAttribute(
            "data-hash"
          );
        }
      }

      if (!(event.to === event.from) || itemParentHash !== newParentHash) {
        // if(!this.validLayout()) return

        // this.$vs.loading({type: 'default'})

        const item = event.item;

        const itemHash = item.getAttribute("data-hash");

        // item.style.display = 'none'

        let fromIsAnchor =
          event.from.querySelector("span.navigation-header") !== null
            ? true
            : false;
        let toIsAnchor =
          event.to.querySelector("span.navigation-header") !== null
            ? true
            : false;

        if (!fromIsAnchor || !toIsAnchor) {
          item.setAttribute("data-remove", true);
        }

        let parentHash = "";

        if (
          event.to.parentElement.tagName.toLowerCase() === "ul" &&
          event.to.parentElement.parentElement.parentElement.parentElement.tagName.toLowerCase() ===
          "section"
        ) {
          // Item de Âncora -> Grupo
          parentHash = item.parentElement.parentElement.parentElement.getAttribute(
            "data-hash"
          );
        } else {
          parentHash = newParentHash;
        }

        if (parentHash !== null) {
          if (
            document
              .querySelector(`[data-hash="${parentHash}"]`)
              .tagName.toLowerCase() === "span"
          ) {
            // ITEM -> Âncora -> Âncora

            const menuItem = await this.$store.dispatch(
              "auth/getMenuItemDetail",
              { hash: item.getAttribute("data-hash") }
            );

            let itemIndex = 0;

            let startIndexCount = false;

            let stopFor = false;

            document
              .querySelector(".vs-sidebar--items > div > section > div")
              .children.forEach(menuItem => {
                if (!stopFor) {
                  if (menuItem.getAttribute("data-hash") === parentHash) {
                    startIndexCount = true;
                  } else {
                    if (menuItem.getAttribute("data-hash") === itemHash) {
                      stopFor = true;
                    } else if (startIndexCount) {
                      itemIndex++;
                    }
                  }
                }
              });

            this.$store.commit("auth/ADD_REMOVE_TAG", menuItem.hash);

            if (menuItem.hasOwnProperty("submenu")) {
              this.$vs.loading({ type: "default" });
              await this.$store.commit("auth/ADD_APPLICATION_MENU_ITEM", {
                parentHash: parentHash,
                hash: menuItem.hash,
                name: menuItem.name,
                url: menuItem.url,
                icon: menuItem.icon,
                submenu: menuItem.submenu,
                index: itemIndex
              });

              this.$vs.loading.close();
            } else {
              this.$vs.loading({ type: "default" });
              await this.$store.commit("auth/ADD_APPLICATION_MENU_ITEM", {
                parentHash: parentHash,
                hash: menuItem.hash,
                name: menuItem.name,
                url: menuItem.url,
                icon: menuItem.icon,
                index: itemIndex
              });
              this.$vs.loading.close();
            }

            this.$store.commit("menuBuilder/SET_UNSAVED_LAYOUT", true);

            setTimeout(() => {
              document
                .querySelectorAll(
                  ".router-link-exact-active.router-link-active"
                )
                .forEach(item => {
                  item.classList.remove("router-link-exact-active");
                  item.classList.remove("router-link-active");
                });

              document
                .querySelectorAll(`[data-remove="true"]`)
                .forEach(item => {
                  item.style.display = "none";
                });

              this.$vs.loading.close();
            }, 300);
          } else {
            // this.$vs.loading({type: 'default'})

            // console.log(item)

            // return

            item.style.display = "none";
            item.setAttribute("data-remove", true);

            const menuItem = await this.$store.dispatch(
              "auth/getMenuItemDetail",
              { hash: item.getAttribute("data-hash") }
            );

            this.$store.commit("auth/ADD_REMOVE_TAG", menuItem.hash);

            let itemIndex = 0;

            let stopFor = false;

            document
              .querySelector(`[data-hash="${parentHash}"] > ul > div`)
              .children.forEach(menuItem => {
                if (!stopFor) {
                  if (menuItem.getAttribute("data-hash") === itemHash) {
                    stopFor = true;

                    itemIndex--;
                  }

                  itemIndex++;
                }
              });

            if (menuItem.hasOwnProperty("submenu")) {
              this.$vs.loading({ type: "default" });
              await this.$store.commit("auth/ADD_APPLICATION_MENU_ITEM", {
                parentHash: parentHash,
                hash: menuItem.hash,
                name: menuItem.name,
                url: menuItem.url,
                icon: menuItem.icon,
                submenu: menuItem.submenu,
                index: itemIndex
              });
              this.$vs.loading.close();
            } else {
              this.$vs.loading({ type: "default" });
              await this.$store.commit("auth/ADD_APPLICATION_MENU_ITEM", {
                parentHash: parentHash,
                hash: menuItem.hash,
                name: menuItem.name,
                url: menuItem.url,
                icon: menuItem.icon,
                index: itemIndex
              });
              this.$vs.loading.close();
            }

            this.$store.commit("menuBuilder/SET_UNSAVED_LAYOUT", true);

            setTimeout(() => {
              document
                .querySelectorAll(
                  ".router-link-exact-active.router-link-active"
                )
                .forEach(item => {
                  item.classList.remove("router-link-exact-active");
                  item.classList.remove("router-link-active");
                });

              document
                .querySelectorAll(`[data-remove="true"]`)
                .forEach(item => {
                  item.style.display = "none";
                });

              this.$vs.loading.close();
            }, 300);
          }
        } else {
          const menu = document.querySelector(
            ".vs-sidebar--items > div > section > div"
          );

          const menuList = [];

          const indexList = {};

          let currentIndex = -1;

          const menuArr = menu.children;

          menuArr.forEach((item, index) => {
            if (item.getAttribute("data-remove") != true) {
              if (item.tagName.toLowerCase() === "span") {
                const anchorObject = {
                  menu_hash: item.getAttribute("data-hash"),
                  menu_name: item.textContent.trim(),
                  index: index,
                  menu_related_items: []
                };

                menuList.push(anchorObject);
                indexList[item.getAttribute("data-hash")] = anchorObject;

                currentIndex++;
              } else {
                if (item.classList.contains("vs-sidebar--item")) {
                  const itemObject = {
                    menu_hash: item.getAttribute("data-hash"),
                    menu_name: item
                      .querySelector("a > span.truncate")
                      .textContent.trim(),
                    index: index,
                    menu_related_items: []
                  };

                  menuList[currentIndex]["menu_related_items"].push(itemObject);
                  indexList[item.getAttribute("data-hash")] = itemObject;
                } else {
                  const groupItem = {
                    menu_hash: item.getAttribute("data-hash"),
                    menu_name: item
                      .querySelector(
                        "div.group-header > span.flex > span.truncate"
                      )
                      .textContent.trim(),
                    index: index,
                    menu_related_items: []
                  };

                  item
                    .querySelector("ul > div")
                    .children.forEach((groupChildItem, groupChildIndex) => {
                      if (
                        groupChildItem
                          .querySelector("div")
                          .classList.contains("vs-sidebar-group")
                      ) {
                        if (
                          groupChildItem
                            .querySelector("div")
                            .classList.contains("vs-sidebar-group")
                        ) {
                          const groupChildElement = groupChildItem.querySelector(
                            "div"
                          );

                          const groupItemChild = {
                            menu_hash: groupChildElement.getAttribute(
                              "data-hash"
                            ),
                            menu_name: groupChildElement
                              .querySelector(
                                "div.group-header > span.flex > span.truncate"
                              )
                              .textContent.trim(),
                            index: groupChildIndex,
                            menu_related_items: []
                          };

                          groupChildElement
                            .querySelector("ul > div")
                            .children.forEach((childItem, childIndex) => {
                              const itemChild = {
                                menu_hash: childItem
                                  .querySelector("div")
                                  .getAttribute("data-hash"),
                                menu_name: childItem
                                  .querySelector("a > span.truncate")
                                  .textContent.trim(),
                                index: childIndex,
                                menu_related_items: []
                              };

                              groupItemChild["menu_related_items"].push(
                                itemChild
                              );
                              indexList[
                                childItem
                                  .querySelector("div")
                                  .getAttribute("data-hash")
                              ] = itemChild;
                            });

                          groupItem["menu_related_items"].push(groupItemChild);
                          indexList[
                            groupChildElement.getAttribute("data-hash")
                          ] = groupItemChild;
                        } else {
                          const item = {
                            menu_hash: groupChildItem
                              .querySelector("div")
                              .getAttribute("data-hash"),
                            menu_name: groupChildItem
                              .querySelector("a > span.truncate")
                              .textContent.trim(),
                            index: groupChildIndex,
                            menu_related_items: []
                          };

                          groupItemChild["menu_related_items"].push(item);
                          indexList[
                            groupChildItem
                              .querySelector("div")
                              .getAttribute("data-hash")
                          ] = item;
                        }
                      } else {
                        const item = {
                          menu_hash: groupChildItem
                            .querySelector("div")
                            .getAttribute("data-hash"),
                          menu_name: groupChildItem
                            .querySelector("a > span.truncate")
                            .textContent.trim(),
                          index: groupChildIndex,
                          menu_related_items: []
                        };

                        groupItem["menu_related_items"].push(item);
                        indexList[
                          groupChildItem
                            .querySelector("div")
                            .getAttribute("data-hash")
                        ] = item;
                      }
                    });

                  menuList[currentIndex]["menu_related_items"].push(groupItem);
                  indexList[item.getAttribute("data-hash")] = groupItem;
                }
              }
            }
          });

          this.$store.commit("auth/SORT_MENU_LIST", indexList);

          this.$store.commit("menuBuilder/SET_UNSAVED_LAYOUT", true);
        }

        this.$store.commit("menuBuilder/SET_UNSAVED_LAYOUT", true);
      } else {
        this.$store.commit("menuBuilder/SET_UNSAVED_LAYOUT", true);
      }
      // this.$store.commit('menuBuilder/SET_CURRENT_ITEM_TO_DELETE', menuItem.hash)

      setTimeout(() => {
        this.$vs.loading.close("#menu-with-loading > .con-vs-loading");
      }, 700);
    },
    onMenuSwipe(event) {
      if (event.direction === 4 && this.$vs.rtl) {
        // Swipe Right
        if (this.isVerticalNavMenuActive && this.showCloseButton)
          this.isVerticalNavMenuActive = false;
      } else if (event.direction === 2 && !this.$vs.rtl) {
        // Swipe Left
        if (this.isVerticalNavMenuActive && this.showCloseButton)
          this.isVerticalNavMenuActive = false;
      }
    },
    onSwipeAreaSwipe(event) {
      if (event.direction === 4 && !this.$vs.rtl) {
        // Swipe Right
        if (!this.isVerticalNavMenuActive && this.showCloseButton)
          this.isVerticalNavMenuActive = true;
      } else if (event.direction === 2 && this.$vs.rtl) {
        // Swipe Left
        if (!this.isVerticalNavMenuActive && this.showCloseButton)
          this.isVerticalNavMenuActive = true;
      }
    },
    psSectionScroll() {
      const scroll_el =
        this.$refs.verticalNavMenuPs.$el || this.$refs.verticalNavMenuPs;
      this.showShadowBottom = scroll_el.scrollTop > 0;
    },
    mouseEnter() {
      if (this.reduce)
        this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", false);
      this.isMouseEnter = true;
    },
    mouseLeave() {
      if (this.reduce)
        this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", true);
      this.isMouseEnter = false;
    },
    setVerticalNavMenuWidth() {
      if (this.windowWidth > 1200) {
        if (this.layoutType === "vertical") {
          // Set reduce
          this.reduce = !!this.reduceButton;

          // Open NavMenu
          this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);

          // Set Menu Items Only Icon Mode
          const verticalNavMenuItemsMin = !!(
            this.reduceButton && !this.isMouseEnter
          );
          this.$store.commit(
            "UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN",
            verticalNavMenuItemsMin
          );

          // Menu Action buttons
          this.clickNotClose = true;
          this.showCloseButton = false;

          const verticalNavMenuWidth = this.isVerticalNavMenuReduced
            ? "reduced"
            : "default";
          this.$store.dispatch(
            "updateVerticalNavMenuWidth",
            verticalNavMenuWidth
          );

          return;
        }
      }

      // Close NavMenu
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);

      // Reduce button
      if (this.reduceButton) this.reduce = false;

      // Menu Action buttons
      this.showCloseButton = true;
      this.clickNotClose = false;

      // Update NavMenu Width
      this.$store.dispatch("updateVerticalNavMenuWidth", "no-nav-menu");

      // Remove Only Icon in Menu
      this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", false);

      // if(this.layoutType === 'vertical' || (this.layoutType === 'horizontal' && this.windowWidth < 1200))
      // if (this.windowWidth < 1200) {

      //   // Close NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)

      //   // Reduce button
      //   if (this.reduceButton) this.reduce = false

      //   // Menu Action buttons
      //   this.showCloseButton = true
      //   this.clickNotClose   = false

      //   // Update NavMenu Width
      //   this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')

      //   // Remove Only Icon in Menu
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)

      // } else {

      //   // Set reduce
      //   this.reduce = this.reduceButton ? true : false

      //   // Open NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)

      //   // Set Menu Items Only Icon Mode
      //   const verticalNavMenuItemsMin = (this.reduceButton && !this.isMouseEnter) ? true : false
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', verticalNavMenuItemsMin)

      //   // Menu Action buttons
      //   this.clickNotClose   = true
      //   this.showCloseButton = false

      //   const verticalNavMenuWidth   = this.isVerticalNavMenuReduced ? "reduced" : "default"
      //   this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)
      // }
    },
    toggleReduce(val) {
      this.reduceButton = val;
      this.setVerticalNavMenuWidth();
    }
  },
  created() {
    this.appTitle = JSON.parse(
      getApplicationLocalStorageItem("web")
    ).web_tab_name;
    const role = JSON.parse(getApplicationLocalStorageItem("role"));
    this.homeUrl = role["home_url"];

    // setTimeout(() => {

    // setTimeout( ()=> {
    //   this.$vs.loading.close('#menu-with-loading > .con-vs-loading')
    // }, 10000)

    // }, 3000)
  },
  mounted() {
    this.setVerticalNavMenuWidth();

    setTimeout(() => {
      this.iconOptions = this.$store.state.menuBuilder.icons;
    }, 300);
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/verticalNavMenu.scss";
</style>
